export default __webpack_public_path__ + "static/media/bullying.0e9d7634.png";